export const MEDIA_QUERY_SMALL = "(min-width: 600px)";
